// extracted by mini-css-extract-plugin
module.exports = {"section":"FixProcess_section__PNE_N"};